<template>
  <div class="login-container" v-if="pageReady">
    <div class="logo">
      <img v-if="!isIstore" style="height: 60px" src="../../assets/sfclogo.png" />
    </div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" label-position="left"
      @submit.native.prevent>
      <h3 class="title">

        {{ isIstore ? '信息化管理平台' : '三态股份信息化管理平台' }}
      </h3>
      <el-row>
        <div class="qr" v-if="qrUrl">
          <img :src="qrUrl" alt="qr" />
        </div>
        <el-form-item prop="googleAuthCode" :error="errorMsg">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input v-model="loginForm.googleAuthCode" name="googleAuthCode" auto-complete="on" placeholder="身份验证器验证码"
            @input="replaceWord" @keyup.enter.native.prevent="handleLogin" :controls="false" />
        </el-form-item>
        <div class="clear"></div>
        <el-form-item>
          <el-button :loading="loading" type="primary" style="width: 100%"
            @click.native.prevent="handleLogin">提交</el-button>
        </el-form-item>
        <a href="https://p1oc8b34mgk.feishu.cn/docx/VgBcdt43jokSylx1PzecSp2Wn0g" target="_blank"
          style="font-size:14px;color: #c6c8d1;cursor: pointer;">
          <i class='el-icon-warning-outline' style="margin-right: 5px;"></i>登录操作指引</a>
      </el-row>
    </el-form>
    <div class="footer-bottom">
      Copyright © 2021 <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">{{ editionStr }}</a>
      All right reserved
    </div>
  </div>
</template>
<script>
import { getQr, ddCodeLogin } from '@/api/special-login'
import { toLink } from '@/utils/index'
import { getToken, getPowerInfo } from '@/utils/auth'
import { checkTokenValid } from '@/api/login'
// import { getLocalIp } from '@/api/login'
// 服务端明确判定 token 不可用的业务码：000008 token不可用；401 token过期或校验不通过
const TOKEN_INVALID_CODES = [401, '000008']
export default {
  data() {
    return {
      pageReady: false,
      redirect: '',
      qrUrl: '',
      isCode: false,
      loginType: 'password',
      loginForm: {
        googleAuthCode: '',
        username: '',
        password: '',
        googleAuthSecret: ''
      },
      loginRules: {
        googleAuthCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      errorMsg: '',
      loading: false,
      pwdType: 'password',
      editionStr: '三态股份信息化管理平台',
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        console.log(route, 'route')
        if (route.query && route.query.redirect) {
          this.redirect = route.query.redirect
        } else {
          // 飞书扫码回跳：redirect 不再走飞书 state（会被解码损坏成逗号黏连），改从 localStorage 读取
          const saved = localStorage.getItem('redirect')
          if (saved) {
            this.redirect = saved
          }
        }
      },
      immediate: true
    },
  },
  computed: {
    isIstore() {
      return this.$store.getters.isIstore;
    },
  },
  mounted() {
    // 检查URL是否携带dingCode（钉钉工作台跳转过来的场景）
    const dingCode = this.$route.query.dingCode;
    if (dingCode) {
      // 如果当前已登录，判断token过期时间决定是否需要重新验证
      if (getToken()) {
        try {
          const powerInfoData = getPowerInfo();
          let expireTime = null;
          if (powerInfoData && powerInfoData.expire) {
            expireTime = Number(powerInfoData.expire) * 1000; // 秒转毫秒
          } else if (powerInfoData && powerInfoData.token) {
            // cookie中没有expire字段，从JWT token的payload中解析exp
            const payload = JSON.parse(atob(powerInfoData.token.split('.')[1]));
            if (payload.exp) {
              expireTime = Number(payload.exp) * 1000;
            }
          }
          if (expireTime) {
            const now = Date.now();
            const oneHour = 60 * 60 * 1000;
            if (expireTime - now >= oneHour) {
              // 距离超时时间大于等于1小时，直接进入系统
              toLink().then(path => {
                this.redirectAfterLogin(path)
              })
              return;
            }
            // 距离超时时间小于1小时，走验证码登录逻辑
          }
        } catch (e) {
          // getPowerInfo解析失败，走验证码登录逻辑
        }
      }
      this.initByDingCode(dingCode, 'dingding');
      return;
    }

    // 检查URL是否携带feishuCode（飞书工作台跳转过来的场景）
    // let feishuCode = this.$route.query.feishuCode
    const feishuCode = this.$route.query.loginfrom === 'feishu' ? this.$route.query.code : this.$route.query.feishuCode;
    if (feishuCode) {
      this.handleFeishuCallback(feishuCode);
      return;
    }

    // 非钉钉/飞书工作台跳转：从store读取account信息
    this.initByAccount();
  },
  methods: {
    // 飞书回调：本地 token 未过期不代表服务端仍然认可，
    // 直进系统前先向服务端确认；确认不可用则清掉本地登录信息，用 URL 里的 code 重新换码。
    handleFeishuCallback(feishuCode) {
      this.checkLocalTokenUsable().then(usable => {
        if (usable) {
          toLink().then(path => {
            this.redirectAfterLogin(path)
          })
          return;
        }
        this.initByDingCode(feishuCode, 'feishu');
      })
    },
    // true：可沿用本地 token 直进系统；false：必须用 code 重新走验证码登录
    checkLocalTokenUsable() {
      if (!getToken()) {
        return Promise.resolve(false)
      }
      let expireTime = null
      try {
        const powerInfoData = getPowerInfo();
        if (powerInfoData && powerInfoData.expire) {
          expireTime = Number(powerInfoData.expire) * 1000; // 秒转毫秒
        } else if (powerInfoData && powerInfoData.token) {
          // cookie中没有expire字段，从JWT token的payload中解析exp
          const payload = JSON.parse(atob(powerInfoData.token.split('.')[1]));
          if (payload.exp) {
            expireTime = Number(payload.exp) * 1000;
          }
        }
      } catch (e) {
        // getPowerInfo解析失败，按本地登录信息不可用处理
        return Promise.resolve(false)
      }
      const oneHour = 60 * 60 * 1000;
      if (!expireTime || expireTime - Date.now() < oneHour) {
        // 距离超时时间小于1小时，走验证码登录逻辑
        return Promise.resolve(false)
      }
      // 距离超时时间大于等于1小时：再向服务端确认 token 是否仍然可用
      return checkTokenValid().then(() => {
        return true
      }).catch(error => {
        const status = error.response && error.response.status
        if (TOKEN_INVALID_CODES.includes(error.code) || TOKEN_INVALID_CODES.includes(status)) {
          // 服务端明确判定 token 不可用，清掉本地登录信息，避免继续带给子系统
          return this.$store.dispatch('FedLogOut').then(() => false)
        }
        // 其它异常无法判定 token 失效，保持原有直进系统的行为
        return true
      })
    },
    redirectAfterLogin(fallbackPath) {
      if (this.redirect) {
        localStorage.removeItem('redirect') // 用完即清，避免下次登录被旧值带偏
        window.location.href = this.buildRedirectUrl(this.redirect)
      } else {
        this.$router.push({ path: fallbackPath || '/' })
      }
    },
    // SSO authorize（如阿里企业云盘 SP-initiated）需要先建会话：
    // 先过 set-session 用 JWT 设 SSO cookie，再回 authorize；其它 redirect 原样返回。
    buildRedirectUrl(redirect) {
      if (redirect.indexOf('/user-service/sso/authorize') > -1) {
        const Base64 = require('js-base64').Base64
        const code = Base64.encode(JSON.stringify({ token: getToken() }))
        const setSessionUrl = process.env.NODE_ENV === 'production'
          ? 'https://apiaccount.suntekcorps.com/user-service/sso/set-session'
          : process.env.VUE_APP_BASE_API + '/sso/set-session'
        return setSessionUrl
          + '?code=' + encodeURIComponent(code)
          + '&redirect=' + encodeURIComponent(redirect)
      }
      return redirect
    },
    // 钉钉/飞书工作台跳转：用code请求后端，获取验证状态
    initByDingCode(code, loginType) {
      // 从工作台进来的要区分于扫码的，加上 workplace:true
      const params = {
        workplace: true
      };

      // 根据登录类型设置不同的code参数
      if (loginType === 'dingding') {
        params.dingCode = code;
      } else if (loginType === 'feishu') {
        params.feishuCode = code;
      }

      ddCodeLogin(params).then(response => {
        // 请求返回后清空地址栏的code，防止刷新页面重复请求
        const query = this.redirect ? { redirect: this.redirect } : {}
        this.$router.replace({ path: this.$route.path, query })
        if (['0000013', '0000014', '0000015', '0000016'].includes(response.code)) {
          // 保存到store
          this.$store.commit('SET_ACCOUNT', {
            username: response.data.userInfo.username,
            randomId: response.data.randomId,
            password: '',
            code: response.code,
            loginType: loginType,
            loginTmpCode: code
          });
          this.code = response.code;
          this.loginType = loginType;
          this.pageReady = true;

          if (this.code === '0000013') {
            // 首次绑定：获取Google Auth二维码
            const obj = { username: response.data.userInfo.username };
            getQr(obj).then(res => {
              if (res.code === '000000') {
                this.qrUrl = res.data.qr;
                this.loginForm.googleAuthSecret = res.data.secret;
              }
            })
          }
        } else if (response.code === '000000' && response.data?.token) {
          // getLocalIp().then((res) => {
          //   console.log(res, 'ip')
          //   this.$store.dispatch('setUserIp', res.data || '')
          // }).catch(() => {
          //   this.$store.dispatch('setUserIp', '')
          // })
          response.data.loginType = loginType;
          this.$store.dispatch('saveUserInfo', response.data).then(() => {
            toLink().then(path => {
              this.redirectAfterLogin(path)
            }).catch(() => {
              this.redirectAfterLogin('/')
            })
          }).catch(() => {
            this.$router.push('/login');
          })
        } else {
          this.$message({ message: response.msg || '登录验证失败', type: 'error' });
          this.$router.push('/login');
        }
      }).catch(() => {
        this.$message({ message: '请求失败，请重新登录', type: 'error' });
        this.$router.push('/login');
      });
    },
    // 从store读取account信息（账号密码登录 / 扫码登录跳转）
    initByAccount() {
      const account = this.$store.getters.account;
      this.code = account.code;
      this.loginType = account.loginType || 'password';

      let hasValidInfo = false;
      if (this.loginType === 'dingding') {
        hasValidInfo = !!account.username;
      } else {
        hasValidInfo = account.username && account.password;
      }

      if (hasValidInfo) {
        this.pageReady = true;
        if (this.code === '0000013') {
          const obj = { username: account.username };
          getQr(obj).then(res => {
            if (res.code === '000000') {
              this.qrUrl = res.data.qr;
              this.loginForm.googleAuthSecret = res.data.secret;
            }
          })
        }
      } else {
        this.qrUrl = '';
        this.$router.push('/login');
      }
    },
    replaceWord() {
      this.loginForm.googleAuthCode = this.loginForm.googleAuthCode.replace(/[^\d]/g, '');
    },
    showPwd() {
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password';
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let account = this.$store.getters.account;
          let loginType = account.loginType || 'password';
          let obj = {};

          if (loginType === 'dingding' || loginType === 'feishu') {
            // 钉钉扫码登录：用后端返回的username，不传密码
            if (!account.username) {
              this.$message({ message: '登录信息已失效，请重新登录', type: 'error' });
              this.$router.push('/login');
              return;
            }
            obj = {
              // "loginTmpCode": account.loginTmpCode,
              "randomId": account.randomId,
              "username": account.username,
              "googleAuthSecret": this.loginForm.googleAuthSecret,
              "googleAuthCode": this.loginForm.googleAuthCode,
              "loginType": loginType
            }
          } else {
            // 账号密码登录：传username和password
            if (!account.username || !account.password) {
              this.$message({ message: '请先登录', type: 'error' });
              this.$router.push('/login');
              return;
            }
            obj = {
              "username": account.username,
              "password": account.password,
              "googleAuthSecret": this.loginForm.googleAuthSecret,
              "googleAuthCode": this.loginForm.googleAuthCode,
              "loginType": loginType
            }
          }

          this.$store.dispatch('qrLogin', obj).then((res) => {
            this.loading = false;
            if (res.code === '000000') {
              if (this.redirect && this.redirect.indexOf('jumpServer') > -1) {
                let object = {
                  token: res.data.token
                }
                object = JSON.stringify(object)
                const Base64 = require('js-base64').Base64
                const urlCode = Base64.encode(object)
                const url = this.redirect.split('?')[0]
                window.location.href = url + 'core/auth/login/new/?code=' + urlCode
                return
              }
              // 判断是否需要跳转到重置密码页（账号密码登录且首次登录）
              const isFirstLogin = res.data.userInfo?.isFirstLogin;
              const isExpiredPassword = res.data.userInfo?.expiredPassword;
              const loginType = account.loginType || 'password';
              const isThirdPartyLogin = loginType === 'dingding' || loginType === 'feishu';

              if ((isFirstLogin || isExpiredPassword) && !isThirdPartyLogin) {
                this.$router.push({ path: '/resetPassword', replace: true });
                return;
              }

              toLink().then(path => {
                this.redirectAfterLogin(path)
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              });
            }
          }).finally(() => {
            this.loading = false;
          })
        } else {
          return false;
        }
      });
    },
    checkUser() {
      this.errorMsg = '';
      if (this.loginForm.username) {
        this.$store
          .dispatch('checkUser', this.loginForm.username)
          .then((res) => {
            if (res) {
              this.errorMsg = res;
            }
          });
      }
    },
    changeLog() {
      this.isCode = !this.isCode;
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$light_gray: #eee;

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;

  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    max-width: 100%;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;

    .code-tab {
      // height: 248px;
      // background: #ccc;
      width: 100%;
      text-align: center;

      h5 {
        font-size: 16px;
        color: #2f2c2c;
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title {
    font-size: 26px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .clear {
    clear: both;
  }
}

.logo {
  position: absolute;
  display: flex;
  height: 60px;
  line-height: 60px;
  left: 5px;
  top: 10px;
  vertical-align: middle;
  color: #fff;
}

.footer-bottom {
  line-height: 44px;
  flex-grow: 1;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  font-weight: 500;
  color: #c6c8d1;
  text-align: center;
  width: 100%;
  border-top: 1px solid #3f3b5c;
}

.qr {
  text-align: center;
  margin-bottom: 20px;

  img {
    width: 200px;
    height: 200px;
  }
}

.myinput {
  border: none;
  outline: none;
  width: 80%;
  height: 52px;
  padding-left: 15px;
  background-color: transparent;
  color: #fff;
}
</style>
